import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { SidebarMenuMain } from "./SidebarMenuMain"
import { DrawerComponent, MenuComponent, ScrollComponent, ToggleComponent } from "@common-metronic/assets/ts/components"

const SidebarMenu = () => {
     const { pathname } = useLocation()
     const scrollRef = useRef<HTMLDivElement>(null)

     useEffect(() => {
          // Wait for the DOM to be fully painted with new menu items
          setTimeout(() => {
               DrawerComponent.reinitialization()
               MenuComponent.reinitialization()
               ScrollComponent.reinitialization()
               ToggleComponent.reinitialization()

               // Force update the specific scroll wrapper if the general reinit doesn't catch it
               if (scrollRef.current) {
                    ScrollComponent.createInstance(scrollRef.current)
                    const scrollInstance = ScrollComponent.getInstance(scrollRef.current)
                    scrollInstance?.update()
               }
          }, 500) // 500ms delay to ensure React has finished rendering permissions
     }, [pathname])

     return (
          <div className="app-sidebar-menu overflow-hidden flex-column-fluid">
               <div
                    id="kt_app_sidebar_menu_wrapper"
                    ref={scrollRef}
                    className="app-sidebar-wrapper hover-scroll-overlay-y my-5"
                    data-kt-scroll="true"
                    data-kt-scroll-activate="true"
                    data-kt-scroll-height="auto"
                    data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
                    data-kt-scroll-wrappers="#kt_app_sidebar_menu"
                    data-kt-scroll-offset="5px"
                    data-kt-scroll-save-state="true"
               >
                    <div className="menu menu-column menu-rounded menu-sub-indention px-3" id="#kt_app_sidebar_menu" data-kt-menu="true" data-kt-menu-expand="false">
                         <SidebarMenuMain />
                    </div>
               </div>
          </div>
     )
}

export { SidebarMenu }
